import './components/common/accordion';
import { initYoutubeVideos } from './components/common/youtube';
import './components/features';
import './components/splide/media-about';
import './pages/about-us';
// import './pages/about'; odkomentować, gdy about-us bedzie z localazy
import './pages/career';
initYoutubeVideos();
